import * as actionTypes from '../actions/actionTypes';

const initialState = {  
  businessDetails:{},  
  countryDetails:{},  
  busineeUnitlocationDetails:{},  
  yearList: null,
  isLoading: false,
  isError: false
}

const dashboardReducer = (state = initialState, action = {}) => {

  const newState = { ...state };

  switch (action.type) {
    case actionTypes.FETCH_COUNTRY_DETAILS:
      return { ...newState, isLoading: true };

    case actionTypes.FETCH_COUNTRY_DETAILS_SUCCESS:
      return { ...newState, isLoading: false, businessDetails: { ...action.payload } };

    case actionTypes.FETCH_COUNTRY_DETAILS_FAILURE:
    return { ...newState, isLoading: false, businessDetails: { ...action.payload }, isError: true };

    case actionTypes.FETCH_LOCATION_DETAILS:
      return { ...newState, isLoading: true };

    case actionTypes.FETCH_LOCATION_DETAILS_SUCCESS:
      return { ...newState, isLoading: false, countryDetails: { ...action.payload } };

    case actionTypes.FETCH_LOCATION_DETAILS_FAILURE:
    return { ...newState, isLoading: false, countryDetails: { ...action.payload }, isError: true };

    case actionTypes.FETCH_BUSINESS_DETAILS:
      return { ...newState, isLoading: true };

    case actionTypes.FETCH_BUSINESS_DETAILS_SUCCESS:
      return { ...newState, isLoading: false, busineeUnitlocationDetails: { ...action.payload } };

    case actionTypes.FETCH_BUSINESS_DETAILS_FAILURE:
      return { ...newState, isLoading: false, busineeUnitlocationDetails: { ...action.payload }, isError: true };

    case actionTypes.FETCH_YEAR_SUCCESS:
      return { ...newState, isLoading: false, yearList: { ...action.payload } };

    case actionTypes.FETCH_YEAR_FAILURE:
    return { ...newState, isLoading: false, yearList: { ...action.payload }, isError: true };

    default:
      return { ...newState };
  }
};


export default dashboardReducer;